// extracted by mini-css-extract-plugin
export default {"projectWrapper":"ProjectV2ItemStatusChangedEvent-module__projectWrapper--hBPof"};